'use client';

import React from 'react';
import { BuilderBlocks, BuilderElement } from '@builder.io/react';
import { SpacingType, sectionVariants } from "@/types";
import { SectionWrapper } from '../components/SectionWraper';

interface SectionProps {
  darkMode?: boolean;
  variant?: sectionVariants;
  spacing?: SpacingType;
  usedInPageNav?: boolean;
  pageNavTitle?: string;
  useContainer?: boolean;
  hasShapeBackground?: boolean;
  themeChangeOnScroll?: boolean;
  builderBlock: BuilderElement;
  attributes?: React.HTMLProps<HTMLElement>;
  leftColumnContent?: BuilderElement[];
  rightColumnContent?: BuilderElement[];
}

export const ContactUsPageSection = ({ 
  builderBlock, 
  spacing,  
  useContainer, 
  darkMode = false, 
  variant = 'A', 
  usedInPageNav = false, 
  pageNavTitle = 'Section', 
  themeChangeOnScroll = false, 
  attributes,
  hasShapeBackground = false,
  leftColumnContent,
  rightColumnContent
}: SectionProps) => {
  const containerClass = useContainer ? 'container' : '';
  const sectionClass = hasShapeBackground ? 'bg-position-[25%_0px] lg:bg-position-[75%_0px]' : '';
  const sectionStyle = 
    hasShapeBackground ? {
      backgroundImage: "url('/background-graph.svg')",
      backgroundSize: "auto",
      backgroundRepeat: "no-repeat",
      // backgroundAttachment: "fixed",
    } : {};
  
  return (
    <SectionWrapper
      usedInPageNav={usedInPageNav}
      pageNavTitle={pageNavTitle}
      themeChangeOnScroll={themeChangeOnScroll}
      spacing={spacing}
      variant={variant}
      darkMode={darkMode}
      heroSection={false}
      componentName="section"
      attributes={attributes}
      style={sectionStyle}
      className={sectionClass}
    > 
      <div className={containerClass}>
        <div className="flex flex-col lg:flex-row gap-6 lg:gap-8">
          {/* Always render first column */}
          <div className="flex flex-col w-full lg:w-2/5 2xl:w-1/2">
            <BuilderBlocks
              parentElementId={builderBlock?.id}
              dataPath="leftColumnContent"
              blocks={leftColumnContent ?? []}
            />
          </div>
          
          {/* Render second column for 2+ columns */}
          <div className="flex flex-col w-full lg:w-3/5 2xl:w-1/2">
            <BuilderBlocks
              parentElementId={builderBlock?.id}
              dataPath="rightColumnContent"
              blocks={rightColumnContent ?? []}
            />
          </div>
        </div>
      </div>
    </SectionWrapper>
  );
}; 